import { useCallback } from 'react';

import {
  useLocation,
  useNavigate,
  NavigateOptions,
  To,
} from "react-router";

/**
 * Custom hook that preserves query parameters when navigating.
 *
 * @returns A navigate function with the same signature as React Router's useNavigate.
 */
export function useNavigateWithQuery(): (
  to: To,
  options?: NavigateOptions,
) => void {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      let updatedTo: To;

      if (typeof to === 'string') {
        // Append the current query parameters to the URL
        updatedTo = `${to}${location.search}`;
      } else {
        // Merge current query parameters into the object-based `to` argument
        updatedTo = {
          ...to,
          search: to.search || location.search,
        };
      }

      navigate(updatedTo, options);
    },
    [location, navigate],
  );
}
